// extracted by mini-css-extract-plugin
export var container = "_95-0";
export var containerTopRight = "_95-1";